import { Component, inject, OnInit } from '@angular/core';
import { IStatsTileDefinition } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/dashboards/interfaces/tiles/definitions/stats-tile-definition.interface';
import { FilterConditionType } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/interfaces/filters/filter-condition-type.enum';
import { FilterOperatorType } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/interfaces/filters/filter-operator-type.enum';
import { UsersService } from '../../../users/service/users.service';

@Component({
  selector: 'app-my-samples-report',
  template: `
    @if (tileInstance) {
      <suvo-bi-tile-wrapper fxFlex="1 1" class="dashboard-tile" [tileInstance]="tileInstance" />
    }
  `,
})
export class MySamplesReportComponent implements OnInit {
  private readonly userService = inject(UsersService);

  tileInstance: IStatsTileDefinition;

  async ngOnInit() {
    const userId = (await this.userService.getMe())?._id;
    if (userId) {
      this.tileInstance = {
        tileType: 'stats',
        title: 'Your samples',
        statDefinitions: [
          {
            title: 'Total active samples',
            recipe: {
              dataSource: 'samples',
              fullRoute: 'sample-reports',
              metric: 'count',
              filters: {
                name: 'Report Filters',
                query: {
                  op: FilterOperatorType.And,
                  rules: [
                    {
                      key: 'submittedAt',
                      con: [
                        {
                          type: FilterConditionType.NotExists,
                        },
                      ],
                    },
                    {
                      key: 'userId',
                      eq: userId,
                      type: 'OBJECT_ID',
                    },
                  ],
                },
              },
            },
          },
        ],
        canView: true,
        backgroundColor: 'white',
      };
    }
  }
}
